/**
 * Language Modal Component
 */
export class LanguageModal {
    constructor() {
        this.dialog = document.getElementById('language-modal');
        
        if (!this.dialog || this.dialog.tagName !== 'DIALOG') {
            console.warn('LanguageModal: Dialog element not found');
            return;
        }

        this.backdrop = this.dialog.querySelector('.hl-lang-modal__backdrop');
        this.closeBtn = this.dialog.querySelector('.hl-lang-modal__close');
        this.links = this.dialog.querySelectorAll('.hl-lang-modal__item');

        // 전역 인스턴스 설정
        window.languageModalInstance = this;

        this.init();
    }

    init() {
        this.bindEvents();
        
        // Polyfill for older browsers
        if (!this.dialog.showModal) {
            this.dialog.showModal = function() {
                this.style.display = 'block';
                document.body.classList.add('modal-open');
            };
            this.dialog.close = function() {
                this.style.display = 'none';
                document.body.classList.remove('modal-open');
            };
        }
    }

    bindEvents() {
        // Close button
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => this.close());
        }

        // Backdrop click
        if (this.backdrop) {
            this.backdrop.addEventListener('click', (e) => {
                if (e.target === this.backdrop) {
                    this.close();
                }
            });
        }

        // ESC key
        this.dialog.addEventListener('cancel', (e) => {
            e.preventDefault();
            this.close();
        });

        // Language links
        this.links.forEach(link => {
            link.addEventListener('click', () => {
                setTimeout(() => {
                    this.close();
                }, 100);
            });
        });

        // Close on outside click
        this.dialog.addEventListener('click', (e) => {
            if (e.target === this.dialog) {
                this.close();
            }
        });
    }

    open() {
        if (!this.dialog) return;
        if (this.dialog.showModal) {
            this.dialog.showModal();
        } else {
            this.dialog.style.display = 'block';
            document.body.classList.add('modal-open');
        }
        document.body.style.overflow = 'hidden';
        
        // 헤더 버튼의 aria-expanded 업데이트
        const languageBtn = document.getElementById('language-btn');
        if (languageBtn) {
            languageBtn.setAttribute('aria-expanded', 'true');
        }
    }

    close() {
        if (!this.dialog) return;
        if (this.dialog.close) {
            this.dialog.close();
        } else {
            this.dialog.style.display = 'none';
            document.body.classList.remove('modal-open');
        }
        document.body.style.overflow = '';
        
        // 헤더 버튼의 aria-expanded 업데이트
        const languageBtn = document.getElementById('language-btn');
        if (languageBtn) {
            languageBtn.setAttribute('aria-expanded', 'false');
        }
    }
}

